import { types } from './shared';
import { useActions } from '../../hooks';
import { usePrompts } from './usePrompts';
import { PromptsList } from './PromptsList';
import { PromptModal } from './PromptModal';
import { useAppContext } from '../../shared';
import { Button, Dropdown } from '../../components';
import { Form, FormItem, TopPanel } from '../../components';
import { addPrompt, updatePrompt, deletePrompt } from '../../api';
import type { Item, CreateItem, UpdateItem } from './usePrompts';

const Prompts = () => {
  const { meta } = useAppContext();
  const { nodes, refresh, filters, setFilters } = usePrompts();
  const {
    isOpened,
    updating,
    initialValues,
    handleClose,
    handleAdd,
    handleEdit,
    handleStartAdd,
    handleStartEdit,
    handleStartDelete,
  } = useActions<Item, CreateItem, UpdateItem>({
    name: 'Prompt',
    onRefresh: refresh,

    onAdd: addPrompt,
    onEdit: updatePrompt,
    onDelete: deletePrompt,
  });

  return (
    <div className="flex flex-col gap-y-md w-full">
      {!!isOpened && (
        <PromptModal
          loading={updating}
          values={initialValues}
          onClose={handleClose}
          onSumbit={initialValues ? handleEdit : handleAdd}
        />
      )}
      <TopPanel>
        <Form<NonNullable<typeof filters>>
          initialValue={filters}
          onChange={setFilters}
        >
          <FormItem<NonNullable<typeof filters>> name="campaignId" label="">
            <Dropdown
              placeholder="Campaign"
              grow={false}
              options={[
                { value: '', label: 'All Campaigns' },
                ...meta.campaigns,
              ]}
            />
          </FormItem>
          <FormItem<NonNullable<typeof filters>> name="promptType" label="">
            <Dropdown placeholder="Type" grow={false} options={types} />
          </FormItem>
        </Form>
        <Button icon="plus" onClick={() => handleStartAdd()}>
          Add Prompt
        </Button>
      </TopPanel>
      <PromptsList
        data={nodes || []}
        updating={updating}
        onStartEdit={handleStartEdit}
        onStartDelete={handleStartDelete}
      />
    </div>
  );
};

export default Prompts;
